@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title | uppercase}}" [(visible)]="display" showEffect="fade" [modal]="true"
    appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region BODY -->
    <div class="container-md">
      <div class="row mt-4 mb-4">
        <div class="col-sm-6">
          <label for="policyNumber" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    <strong> {{'tableManagement.insurance.description' | translate}} (*)</strong>
                </label>
          <div class="p-0"></div>
          <input type="text" id="policyNumber" class="form-control custom-input" [(ngModel)]="entity.description"
            [disabled]="true">
        </div>
        <div class="col-sm-6">
          <label for="insurance-provider" class="form-label custom-label fw-bold small mb-2 me-2" i18n><strong>{{'tableManagement.financing.start' |
                    translate}}</strong></label>
          <div class="p-0"></div>
          <p-datepicker [(ngModel)]='startDate' [showTime]='false' [style]="{'width':'200px'}"
            showIcon='true' appendTo='body' [firstDayOfWeek]="1" dateFormat='{{i18n.dateFormat}}'
          [disabled]="true"></p-datepicker>
        </div>
      </div>
      <div class="row mt-4 mb-4">
        <div class="col-sm-6">
          <label for="agent" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'tableManagement.financing.end' | translate}}
                </label>
          <div class="p-0"></div>
          <p-datepicker [(ngModel)]='endDate' [showTime]='false' [style]="{'width':'200px'}"
            showIcon='true' appendTo='body' [firstDayOfWeek]="1" dateFormat='{{i18n.dateFormat}}'
          [disabled]="true"></p-datepicker>
        </div>
        <div class="col-sm-6">
          <label for="insurance-vehicle" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{'tableManagement.insurance.cost' |
                    translate}}</label>
          <div class="p-0"></div>
          <div class="col-6 input-wrapper">
            <p-inputNumber [showButtons]="false"  [(ngModel)]="entity.cost" mode="decimal" locale="es-ES"
            (onKeyDown)="onKeyDownDecimal($event)" ></p-inputNumber>
            <span class="input-symbol">€</span>
          </div>
        </div>
      </div>
      <div class="row mt-4 mb-4">
        <div class="col-sm-6">
          <label for="fleetCost" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'tableManagement.insurance.fleetCost' | translate}}
                </label>
          <div class="p-0"></div>
          <div class="col-6 input-wrapper">
            <p-inputNumber [showButtons]="false" [(ngModel)]="entity.fleetCost" mode="decimal" locale="es-ES"
            (onKeyDown)="onKeyDownDecimal($event)" ></p-inputNumber>
            <span class="input-symbol">€</span>
          </div>
        </div>
        <div class="col-sm-6"></div>
      </div>
    </div>
    <!-- #endregion BODY -->
  </div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          <div>
            <button class="btn custom-button" (click)="save()" i18n>
                        {{'general.save' | translate}}
                    </button>
          </div>
        </div>
      </div>
    </ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}

